export default __webpack_public_path__ + "assets/caa136927f23ab2073415d8c7e02f62c.png";